import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import CommentApi from './CommentApi';
import CommentActions from './Components/CommentActions';

let settings;

export default settings = {
    key: 'content/comments',
    zone: 'content',
    path: '/content/comments',
    title: "Comments",
    endpoint: CommentApi.endpoint,
    modelName: 'Comment',
    idKey: 'id',
    primaryKey: 'message',
    indexCaps: ["viewComment"],
    viewCaps: ["viewComment"],
    createCaps: ["createComment"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create"
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            // {
            //     label: "Add New",
            //     path: settings.path + '/create',
            //     caps: settings.createCaps
            // }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: CommentApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['owner', 'parent'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['message', 'status'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Message",
                key: "message",
                type: "text",
            },
            {
                label: "Owner",
                key: "ownerId",
                type: "relationship",
                model: "Users",
            },
            {
                label: "Status",
                key: "status",
                type: "choice",
                options: [
                    { value: "publish", label: "Publish" },
                    { value: "spam", label: "Spam" },
                ]
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Message",
                key: "this",
                format: 'ModelLink'
            },
            {
                label: "Owner",
                key: "owner",
                format: "ModelLink"
            },
            {
                label: "Story",
                key: "parent",
                format: 'ModelLink'
            },
            {
                label: "Status",
                key: "status",
                format: "titleCase"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <CommentActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: CommentApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['owner', 'parent'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit"
            },
        ]

    },
};